import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})

export class TruncatePipe implements PipeTransform {

    transform(value: string, args: string[]): string {

        if (value != null) {
            const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
            const trail = args.length > 1 ? args[1] : '...';
            const limitWithDots = limit ? limit - 3 : 50;
            return value.length > limit ? value.substring(0, limitWithDots) + trail : value;
        }
    }
}
